/**
 * @file 反馈页
 * @author FengGuang(fengguang01@baidu.com)
 */

import {useCallback, useEffect, useState} from 'react';


import {
    fetchSubmit
} from '../../api/pages/feedbackApi';
import {Form, message} from 'antd';
import {fetchGetVCode} from '../../api/components/verifyCodeApi';

// 预请求
let preRequest: any = {
    fetchGetVCode: fetchGetVCode()
};

const useVerifyCode = () => {
    const [verifyCodeImg, setVerifyCodeImg] = useState<string>('');
    const [randomStr, setRandomStr] = useState<string>('');
    const [verifyCodeLoading, setVerifyCodeLoading] = useState<boolean>(false);

    const getVerifyCode = useCallback(async (): Promise<void> => {
        const fetchFunc = preRequest.fetchGetVCode || fetchGetVCode();
        delete preRequest.fetchGetVCode;

        let res;
        setVerifyCodeLoading(true);
        try {
            res = await fetchFunc;
        }
        catch (err) {
            // ignore
        }
        setVerifyCodeLoading(false);
        if (res) {
            setVerifyCodeImg(res.body.result.codeImage || '');
            setRandomStr(res.body.result.randomStr || '');
        }
    }, []);

    useEffect(() => {
        getVerifyCode();
    }, [getVerifyCode]);

    return {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,

        getVerifyCode
    };
};

const useFeedbackStore = () => {
    const {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,

        getVerifyCode
    } = useVerifyCode();

    const [feedbackForm] = Form.useForm();

    const {
        setFields
    } = feedbackForm;

    const submit = useCallback(async (fieldValue: { [field: string]: any }): Promise<void> => {
        const urlSearch = new URLSearchParams(window.location.search.slice(1));
        const res = await fetchSubmit({
            name: fieldValue.name,
            problems: fieldValue.problems,
            phoneNumber: fieldValue.phoneNumber,
            verifyCode: fieldValue.verifyCode,
            randomStr: randomStr,
            source: urlSearch.get('source') || ''
        });
        if (res && res.body) {
            if (res.body.errorCode === 0) {
                // 跳转到成功页
                window.location.pathname = window.location.pathname.replace(
                    /\/feedback$/,
                    '/feedbacksuccess'
                );
            }
            else if (res.body.errorCode === 500 && res.body.errorMsg === '验证码错误') {
                setFields([{
                    name: 'verifyCode',
                    errors: [res.body.errorMsg]
                }]);
                // 刷新验证码
                getVerifyCode();
            }
            else {
                (window as any).DEBUG && message.error(res.body.errorMsg);
            }
        }
    }, [setFields, getVerifyCode, randomStr]);

    return {
        verifyCodeImg,
        randomStr,
        verifyCodeLoading,

        feedbackForm,
        getVerifyCode,
        submit
    };
};

export default useFeedbackStore;
